import { render } from "./FileViewerBreadcrumbs.vue?vue&type=template&id=f107abee&scoped=true&ts=true"
import script from "./FileViewerBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./FileViewerBreadcrumbs.vue?vue&type=script&lang=ts"

import "./FileViewerBreadcrumbs.vue?vue&type=style&index=0&id=f107abee&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f107abee"]])

export default __exports__